// Non auth
export const SIGN_UP_BUTTON_CLICKED = 'Sign Up Button Clicked';
export const LOGIN_BUTTON_CLICKED = 'Login Button Clicked';

//Registration & Login
export const REGISTRATION_STARTED = 'Registration Started';
export const LOGIN_OPENED = 'Login Opened';
export const MOBILE_NUMBER_SCREEN_SHOWN = 'Mobile Number Screen Shown';
export const MOBILE_NUMBER_CONTINUE_CLICKED = 'Mobile Number Continue Clicked';
export const COUNTRY_CODE_SELECTED = 'Country Code Selected';
export const COUNTRY_CODE_LIST_OPENED = 'Country Code List Opened';
export const COUNTRY_CODE_CLICKED = 'Country Code Clicked';
export const CANT_RECOGNISE_NUMBER_SHOWN = 'Cant Recognise Number Shown';
export const CHANGE_PHONE_COUNTRY_CLICKED = 'Change Phone Country Clicked';
export const REENTER_MANUALLY_CLICKED = 'Re-Enter Manually Clicked';
export const ONBOARDING_COMPLETED = 'Onboarding Completed';
export const COMPLETE_PROFILE_BANNER_CLICKED = 'Complete Profile Banner Clicked';
export const FORGOT_PASSCODE_CLICKED = 'Forgot Passcode Clicked';
export const PASSCODE_SET_SHOWN = 'Passcode Set Shown';
export const PASSCODE_SUCCESSFULLY_ENTERED = 'Passcode Successfully Entered';
export const PASSKEY_LOGIN_CLICKED = 'Passkey Login Clicked';
export const PASSKEY_LOGIN_SUCCESS = 'Passkey Login Success';
export const PASSKEY_LOGIN_FAILED = 'Passkey Login Failed';
export const PASSKEY_REGISTERED = 'Passkey Registered';
export const MOBILE_NUMBER_ERROR_SHOWN = 'Mobile Number Error Shown';
export const PERSONAL_INFO_SCREEN_SHOWN = 'Personal Info Screen Shown';
export const PERSONAL_INFO_SCREEN_CONTINUE_CLICKED = 'Personal Info Screen Continue Clicked';
export const ADRESS_SCREEN_SHOWN = 'Adress Screen Shown';
export const ADRESS_SCREEN_CONTINUE_CLICKED = 'Adress Screen Continue Clicked';
export const EMAIL_SCREEN_SHOWN = 'Email Screen Shown';
export const EMAIL_SCREEN_CONTINUE_CLICKED = 'Email Screen Continue Clicked';
export const COMPLETE_PROFILE_PROMO_SHOWN = 'Complete Profile Promo Shown';
export const COMPLETE_PROFILE_CONTINUE_CLICKED = 'Complete Profile Continue Clicked';
export const COMPLETE_PROFILE_NOT_NOW_CLICKED = 'Complete Profile Not Now Clicked';
export const UNSUPPORTED_CHARACTERS_ERROR_SHOWN = 'Unsupported Characters Error Shown';
export const UNSUPPORTED_CHARACTERS_GO_BACK_CLICKED = 'Unsupported Characters Go Back Clicked';
export const UNSUPPORTED_CHARACTERS_ACCEPT_CLICKED = 'Unsupported Characters Accept Clicked';
export const COUNTRY_OF_RESIDENCE_CLICKED = 'Country Of Residence Clicked';
export const SELECT_COUNTRY_OF_RESIDENCE_SCREEN_SHOWN = 'Select Country Of Residence Screen Shown';
export const COUNTRY_OF_RESIDENCE_SELECTED = 'Country Of Residence Selected';
export const PERSONAL_DETAILS_UPDATED_SHOWN = 'Personal Details Updated Shown';
export const RESIDENTIAL_ADDRESS_UPDATED_SHOWN = 'Residential Address Updated Shown';
export const LOGOUT_COMPLETED = 'Logout Completed';
export const CODE_ENTERED = 'Code Entered';
export const ENTER_CODE_SCREEN_SHOWN = 'Enter Code Screen Shown';
export const CODE_ENTERED_WRONG = 'Code Entered Wrong';
export const DID_NOT_GET_CODE_BUTTON_CLICKED = 'Did Not Get Code Button Clicked';
export const DID_NOT_GET_CODE_SCREEN_SHOWN = 'Did Not Get Code Screen Shown';
export const DID_NOT_GET_CODE_RESEND_CLICKED = 'Did Not Get Code Resend Clicked';
export const DID_NOT_GET_CODE_SUPPORT_CLICKED = 'Did Not Get Code Support Clicked';
export const DROPDOWN_LIST_SHOWN = 'Dropdown List Shown';
export const DROPDOWN_LIST_ITEM_SELECTED = 'Dropdown List Item Selected';
export const CHECK_PHONE_NUMBER_BOTTOM_SHEET_SHOWN = 'Check Phone Number Bottom Sheet Shown';
export const USE_THIS_PHONE_NUMBER_CLICKED = 'Use This Phone Number Clicked';

// TOS
export const TERMS_AND_AGREEMENT_SCREEN_SHOWN = 'Terms And Agreement Screen Shown';
export const TERMS_AND_AGREEMENT_ACCEPT_CLICKED = 'Terms And Agreement Accept Clicked';
export const TERMS_AND_AGREEMENT_CONFIRMATION_SCREEN_SHOWN = 'Terms And Agreement Confirmation Screen Shown';
export const TERMS_AND_AGREEMENT_CONTINUE_CLICKED = 'Terms And Agreement Continue Clicked';

// Waiting list
export const WAITLIST_SCREEN_SHOWN = 'Waitlist Screen Shown';
export const WAITLIST_NOTIFY_ME_CLICKED = 'Waitlist Notify Me Clicked';
export const LEAVE_EMAIL_SCREEN_SHOWN = 'Leave Email Screen Shown';
export const LEAVE_EMAIL_SEND_CLICKED = 'Leave Email Send Clicked';
export const EMAIL_ADDED_SCREEN_SHOWN = 'Email Added Screen Shown';

// Global Account
export const GA_MAIN_SCREEN_SHOWN = 'GA Main Screen Shown';
export const GET_CARD_SELECTED = 'Get Card Selected';
export const ADD_MONEY_SELECTED = 'Add Money Selected';
export const GA_TOP_UP_METHOD_SELECTED = 'GA Topup Method Selected';
export const TOP_UP_COMPLETED = 'Topup Completed';
export const EXCHANGE_SELECTED = 'Exchange Selected';
export const EXCHANGE_COMPLETED = 'Exchange Completed';
export const KYC_NOTIFICATION_SHOWN = 'KYC Notification Shown';
export const CARD_MAIN_SCREEN_SHOWN = 'Card MainScreen Shown';
export const NEW_ACCOUNT_ADDED = 'New Account Added';
export const ACCOUNT_CHANGED = 'Account Changed';
export const GET_ACCOUNT_DETAILS = 'Get Account Details';

// Transfer
export const SEND_MONEY_BUTTON_CLICKED = 'Send Money Button Clicked';
export const COUNTRY_AND_METHOD_SCREEN_SHOWN = 'Country And Method Screen Shown';
export const RECEIVING_COUNTRY_SELECTED = 'Receiving Country Selected';
export const DELIVERY_METHOD_SELECTED = 'Delivery Method Selected';
export const ADDITIONAL_INFO_SHOWN = 'Additional Info Shown';
export const RECIPIENTS_LIST_SHOWN = 'Recipients List Shown';
export const RECIPIENT_SELECTED = 'Recipient Selected';
export const RECIPIENT_ADDED = 'Recipient Added';
export const VIEW_RATES_FIRST = 'View Rates First Click';
export const CALCULATOR_SETTING_CHANGED = 'Calculator Setting Changed';
export const SENDING_METHOD_SELECTED = 'Sending Method Selected';
export const NEW_EXTERNAL_CARD_ADDED = 'New External Card Added';
export const CVV_ADDED = 'CVV Added';
export const CONFIRM_SEND_SHOWN = 'Confirm Send Shown';
export const TRANSFER_SEND_CLICKED = 'Transfer Send Clicked';
export const TRANSFER_CONFIRMATION_SHOWN = 'Transfer Confirmation Shown';
export const REPEAT_TRANSFER_BUTTON_CLICKED = 'Repeat Transfer Button Clicked';
export const REQUEST_DELIVERY_OPTION_CLICKED = 'Request Delivery Option Clicked';
export const DELIVERY_METHOD_LIST_SHOWN = 'Delivery Method List Shown';
export const MORE_DETAILS_NEEDED_SCREEN_SHOWN = 'More Details Needed Screen Shown';
export const MORE_DETAILS_NEEDED_CONTINUE_CLICKED = 'More Details Needed Continue Clicked';
export const METHOD_UNAVAILABLE_SHOWN = 'Method Unavailable Shown';
export const DISABLED_METHOD_CLICKED = 'Disabled Method Clicked';
export const IMPROVED_RATE_INFO_CLICKED = 'Improved Rate Info Clicked';
export const RECIPIENT_TYPE_LIST_SHOWN = 'Recipient Type List Shown';
export const RECIPIENT_TYPE_SELECTED = 'Recipient Type Selected';
export const FEE_INFO_CLICKED = 'Fee Info Clicked';
export const CHANGE_PAYMENT_OPTION_CLICKED = 'Change Payment Option Clicked';
export const CVV_DIALOG_SHOWN = 'CVV Dialog Shown';
export const CVV_ENTERED = 'CVV Entered';
export const TRY_NOW_CLICKED = 'Try Now Clicked';
export const PROMO_SCREEN_SHOWN = 'Promo Screen Shown';
export const TRANSFERS_PROMO_SCREEN_SHOWN = 'Transfers Promo Screen Shown';
export const SPECIAL_OFFER_CLICKED = 'Special Offer Clicked';
export const COPY_RRN_CLICKED = 'Copy RRN Clicked';
export const RECIPIENT_DETAILS_SCREEN_SHOWN = 'Recipient Details Screen Shown';
export const RECIPIENT_DETAILS_CONTINUE_CLICKED = 'Recipient Details Continue Clicked';
export const ADDITIONAL_RECIPIENT_INFO_SHOWN = 'Additional Recipient Info Screen Shown';
export const ADDITIONAL_RECIPIENT_CONTINUE_CLICKED = 'Additional Recipient Info Continue Clicked';
export const ADDITIONAL_SENDER_INFO_SHOWN = 'Additional Sender Info Screen Shown';
export const ADDITIONAL_SENDER_INFO_CONTINUE_CLICKED = 'Additional Sender Info Continue Clicked';
export const RESTRICTED_COUNTRY_BOTTOM_SHEET_SHOWN = 'Restricted Country Bottom Sheet Shown';
export const PROMO_ALREADY_APPLIED_BOTTOM_SHEET_SHOWN = 'Promo Already Applied Bottom Sheet Shown';
export const GET_BETTER_RATE_CLICKED = 'Get Better Rate Clicked';
export const OBQ_SCREEN_SHOWN = 'OBQ Screen Shown';
export const OBQ_CONTINUE_CLICKED = 'OBQ Continue Clicked';

// Transfer from Bank Account
export const BANK_ACCOUNT_I_PAID_CLICKED = 'I Paid Clicked';
export const BANK_ACCOUNT_CANCELED_TRANSFER_BUTTON_CLICKED = 'Cancel Transfers Button Clicked';
export const BANK_ACCOUNT_I_WILL_PAY_LATER_BUTTON_CLICKED = 'I Pay Later';
export const BANK_ACCOUNT_PAY_CLICKED = 'Pay With Bank Account Clicked';

// Transfer status
export const TRANSFER_STATUS_DETAILS_CLICKED = 'Transfer Status Details Clicked';
export const TRANSFER_STATUS_SHOWN = 'Transfer Status Shown';

// Requests
export const REQUEST_MONEY_BUTTON_CLICKED = 'Request Money Button Clicked';
export const REQUESTEE_MOBILE_NUMBER_ADDED = 'Requestee Mobile Number Added';
export const REQUESTS_CALCULATOR_ADJUSTED = 'Requests Calculator Adjusted';
export const REQUESTS_PAYMENT_METHOD_SELECTED = 'Requests Payment Method Selected';
export const REQUESTS_NEW_METHOD_ADDED = 'Requests New Method Added';
export const REQUESTS_CONFIRM_SHOWN = 'Requests Confirm Shown';
export const REQUESTS_CONFIRM_CLICKED = 'Request Confirm Clicked';
export const REQUESTS_CONFIRMATION_SHOWN = 'Request Confirmation Shown';
export const REQUEST_SHOWN = 'Request Shown';
export const REQUEST_SEND_CLICKED = 'Request Send Clicked';
export const REQUEST_DECLINED = 'Request Declined';

// KYC
export const INCREASE_LIMITS_SHOWN = 'Increase Limits Shown';
export const VERIFICATION_FAILED_SCREEN_SHOW = 'Verification Failed Screen Shown';
export const INCREASE_LIMITS_CONTINUE_CLICKED = 'Increase Limits Continue Clicked';
export const INCREASE_LIMITS_DOCUMENTS_SELECTED = 'Increase Limits Documents Selected';
export const INCREASE_LIMITS_FAQ_SHOWN = 'Increase Limits FAQ Shown';
export const INCREASE_LIMITS_DOCUMENTS_SUBMITTED = 'Increase Limits Documents Submitted';
export const SENDING_LIMIT_ACHIEVE = 'Sending Limit Achieved';
export const CHAT_BUTTON_CLICKED = 'Chat Button Clicked';
export const HOW_TO_SEND_DOCS_SCREEN_SHOWN = 'How To Send Docs Screen Shown';
export const UZBEKISTAN_RESIDENCY_SCREEN_SHOWN = 'Uzbekistan Residency Screen Shown';
export const UZBEKISTAN_RESIDENCY_CONTINUE_CLICKED = 'Uzbekistan Residency Continue Clicked';
export const OFAKIM_GENDER_VERIFICATION_CONTINUE_CLICKED = 'Ofakim Gender Verification Continue Clicked';
export const OFAKIM_HOW_TO_SEND_DOCS_SCREEN_SHOWN = 'Ofakim How To Send Docs Screen Shown';
export const ID_IN_REVIEW_SCREEN_GOT_IT_CLICKED = 'ID In Review Screen Got It Clicked';
export const ACCOUNT_PURPOSE_SCREEN_SHOWN = 'Account Purpose Screen Shown';
export const ACCOUNT_PURPOSE_CONTINUE_CLICKED = 'Account Purpose Continue Clicked';
export const NOT_NOW_CLICKED = 'Not now Clicked';

// DRAFT TRANSFER
export const VERIFICATION_SCREEN_SHOWN = 'Verification Screen Shown';
export const VERIFY_IDENTITY_CLICKED = 'Verify Identity Clicked';
export const RESUME_TRANSFER_CLICKED = 'Resume Transfer Clicked';
export const TRY_VERIFICATION_AGAIN_CLICKED = 'Try Verification Again Clicked';
export const VERIFY_INDENTITY_BANNER_CLICKED = 'Verify Identity Banner Clicked';
export const INCREASE_LIMITS_BANNER_CLICKED = 'Increase Limits Banner Clicked';

//Fraud block
export const FRAUD_SUSPICIOUS_SCREEN_SHOWN = 'Fraud Suspicious Screen Shown';
export const FROZEN_ACCOUNT_SCREEN_SHOWN = 'Frozen Account Screen Shown';
export const BLOCK_GUIDANCE_SCREEN_SHOWN = 'Block Guidance Screen Shown';
export const CONTACT_SUPPORT_CLICKED = 'Contact Support Clicked';
export const ADVANCED_ERROR_SCREEN_SHOWN = 'Advanced Error Screen Shown';

//Paysend Plus
export const PLUS_PROMO_BANNER_CLICKED = 'Plus Promo Banner Clicked';
export const PLUS_INITIAL_SCREEN_SHOWN = 'Plus Initial Screen Shown';
export const PLUS_SUBSCRIBE_BUTTON_CLICKED = 'Plus Subscribe Button Clicked';
export const HOW_PLUS_WORKS_SCREEN_SHOWN = 'How Plus Works Screen Shown';
export const HOW_TRANSFERS_WORKS_SCREEN_SHOWN = 'How Transfers Works Screen Shown';
export const PLUS_SELECT_PAYMENT_CLICKED = 'Plus Select Payment Clicked';
export const PLUS_PAYMENT_SUMMARY_SCREEN_SHOWN = 'Plus Payment Summary Screen Shown';
export const PLUS_CONFIRM_SUBSCRIPTION_CLICKED = 'Plus Confirm Subscription Clicked';
export const PLUS_SEND_TRANSFER_CLICKED = 'Plus Send Transfer Clicked';
export const PLUS_UPDATE_PAYMENT_CLICKED = 'Plus Update Payment Clicked';
export const PLUS_UPDATE_PAYMENT_SUCCESS = 'Plus Update Payment Success';
export const PLUS_BENEFIT_PROMO_SHOWN = 'Plus Benefit Promo Shown';
export const PLUS_PROMO_CODE_SAVED = 'Plus Promo Code Saved';

//Uniteller cash pickup
export const PAYOUT_NETWORKS_LIST_SHOWN = 'Payout Networks List Shown';
export const PAYOUT_NETWORK_SELECTED = 'Payout Network Selected';
export const CALCULATOR_SCREEN_SHOWN = 'Calculator Screen Shown';
export const SENDING_METHOD_SCREEN_SHOWN = 'Sending Method Screen Shown';
export const TRANSFER_SHOWN = 'Transfer Shown';
export const NOTIFY_RECIPIENT_CLICKED = 'Notify Recipient Clicked';
export const NOTIFY_RECIPIENT_SCREEN_SHOWN = 'Notify Recipient Screen Shown';
export const SHARE_DETAILS_CLICKED = 'Share Details Clicked';

// Payout Disclaimer screens
export const PAYOUT_METHOD_GUIDE_SCREEN_SHOWN = 'Payout Method Guide Screen Shown';
export const PAYOUT_METHOD_GUIDE_BUTTON_CLICKED = 'Payout Method Guide Button Clicked';

//Incompleted transfers
export const AWAITING_TRANSFER_CLICKED = 'Awaiting Transfer Clicked';
export const INCOMPLETE_TRANSFER_METHOD_NOT_AVAILABLE_SHOWN = 'Incomplete Transfer Method Not Available Shown';

// Anti fraud flow
export const AF_PURPOSE_OF_TRANSFERS_CONTINUED_CLICKED = 'AF Purpose of Transfers Continued Clicked';
export const AF_TRANSACTIONS_DETAILS_CONTINUED_CLICKED = 'AF Transaction’s Details Continued Clicked';
export const AF_VERIFYING_PAYMENT_CARD_SCREEN_PROMO_SHOWN = 'AF Verifying payment card: screen Promo Shown';
export const AF_VER_PAYMENT_CARD_ENTERED_VER_AMOUNT_CONT_CLICKED = 'AF Verifying payment card: Entered Verification Amount Continued Clicked';
export const AF_VERIFYING_PAYMENT_CARD_AMOUNT_CONFIRMATION_COMPLETED = 'AF Verifying payment card: Amount Confirmation Completed';
export const AF_REQUESTING_IDENTITY_DOCUMENT_PROMO_SCREEN_SHOWN = 'AF Requesting identity document Promo Screen Shown';
export const AF_REQUESTING_IDENTITY_DOCUMENT_DOCUMENT_SELECTED = 'AF Requesting identity document Document Selected';
export const AF_REQUESTING_IDENTITY_DOCUMENT_FAQ = 'AF Requesting identity document FAQ';
export const AF_REQUESTING_IDENTITY_DOCUMENT_SUBMITTED_SHOWN = 'AF Requesting identity document Submmited Shown';
export const AF_REQUESTING_IDENTITY_MOTION_SUBMITTED_SHOWN = 'AF Requesting identity Motion Submmited Shown';
export const AF_ONFIDO_IN_REVIEW_PROMO_GOT_IT_CLICKED = 'AF Onfido In Review Promo Got it Clicked';
export const AF_PROMO_PAYMENT_METHOD_VERIF_CONTINUE_CLICKED = 'AF Promo Payment method verification Continue Clicked';

export const AF_MORE_INFO_ABOUT_RECIPIENT_CONTINUE_CLICKED = 'AF More Info About Recipient Continue Clicked';
export const AF_NOTIFY_RECIPIENT_SCREEN_SHOWN = 'AF Notify Recipient Screen Shown';
export const AF_RECIPIENT_DETAILS_REQUIRED_BANNER_CLICKED = 'AF Recipient Details Required Banner Clicked';
export const AF_RECIPIENT_VERIFICATION_LINK_COPY_CLICKED = 'AF Recipient Verification Link Copy Clicked';
export const AF_RECIPIENT_IDENTITY_REQUEST_PROMO_CONTINUE_CLICKED = 'AF Recipient Identity Request Promo Screen Continue Clicked';
export const AF_RECIPIENT_PERSONAL_DATA_PROCESSING_AGREE_CLICKED = 'AF Recipient Personal Data Processing Agree Clicked';
export const AF_RECIPIENT_EMAIL_CONTINUE_CLICKED = 'AF Recipient Email Continue Clicked';
export const AF_RECIPIENT_ONFIDO_IN_REVIEW_PROMO_DONE_CLICKED = 'AF Recipient Onfido In Review Promo Done Clicked';

export const AF_CHAT_BOT_BUTTON_CLICKED_WITH_SOURCE_OF_PAYMENT = 'AF Chat Bot Button Clicked with Source of Payment';
export const SOF_SCREEN_SHOWN = 'SoF Screen Shown';
export const SOF_SELECTED = 'SoF Selected';

//Linked cards
export const CARD_VERIFICATION_CONTINUE_CLICKED = 'Verification Continue Clicked';
export const CARD_VERIFICATION_SCREEN_SHOWN = 'Card Verification Screen Shown';
export const CARD_VERIFICATION_COMPLETED = 'Card Verification Completed';

//Business payments landing
export const BUSINESS_PAYMENT_LANDING_PAGE_VIEWED = 'Landing page viewed';

// Transfer statement
export const GET_TRANSFER_STATEMENT_CLICKED = 'Get Transfer Statement Clicked';
export const TIME_PERIOD_CLICKED = 'Time Period Clicked';
export const CUSTOM_DATES_CONTINUE_CLICKED = 'Custom Dates Continue Clicked';
export const SEND_STATEMENT_CLICKED = 'Send Statement Clicked';
export const STATEMENT_SENT_SHOWN = 'Statement Sent Shown';

//Opt in Beta Migration 3.0
export const OPT_IN_BETA_CLICKED = 'Opt in to beta Clicked';
export const OPT_IN_BETA_JOINED_SCREEN_SHOWN = 'Opt in to beta Joined Screen Shown';
export const OPT_IN_BETA_SCREEN_SHOWN = 'Opt in to beta Promo Screen Shown';
export const OPT_IN_BETA_MIGRATION_SCREEN_SHOWN = 'Opt in to beta Migration Screen Shown';
export const PREPARE_ACCOUNT_SCREEN_SHOWN = 'Prepare Account Screen Shown';
export const PREPARE_ACCOUNT_CONTINUE_CLICKED = 'Prepare Account Continue Clicked';

//Profile and Bonuses
export const BONUS_INVITATION_CLICKED = 'Send Invitation Clicked';
export const SHARE_LINK_CLICKED = 'Share Link Clicked';
export const SHARE_LINK_CONFIRM_CLICKED = 'Share Link Confirm Clicked';
export const COPY_INVITE_LINK_CLICKED = 'Copy Invite Link Clicked';
export const COPY_INVITE_CODE_CLICKED = 'Copy Invite Code Clicked';
export const TRACK_MY_REFERRALS_CLICKED = 'Track My Referrals Clicked';
export const INVITE_FRIENDS_CLICKED = 'Invite Friends Clicked';
export const PROFILE_SCREEN_SHOWN = 'Profile Screen Shown';
export const BANNER_CLICKED = 'Banner Clicked';

//Payee Online validation
export const PAYEE_USE_BANK_DETAILS_CLICKED = 'Use Bank Details Clicked';
export const PAYEE_GO_BACK_EDIT_CLICKED = 'Go Back Edit Clicked';
export const PAYEE_CONTINUE_ANYWAY_CLICKED = 'Continue Anyway Clicked';
export const PAYEE_PROCEED_DETAILS_CLICKED = 'Proceed With Details Clicked';
export const PAYEE_CLOSE_MATCH_SHOWN = 'Payee Close Match Shown';
export const PAYEE_CLOSE_MATCH_WARNING_SHOWN = 'Payee Close Match Warning Shown';
export const PAYEE_MISMATCH_SHOWN = 'Payee Mismatch Shown';
export const PAYEE_MISMATCH_WARNING_SHOWN = 'Payee Close Match Warning Shown';

// Errors
export const ERROR_SCREEN_SHOWN = 'Error Screen Shown';
export const ERROR_SCREEN_TRY_AGAIN_SHOWN = 'Error Screen Try Again Shown';
export const ERROR_SCREEN_TRY_AGAIN_CLICKED = 'Error Screen Try Again Clicked';

// FAQ & Chat, Problem report
export const GET_HELP_CLICKED = 'Get Help Clicked';
export const GET_CHAT_CLICKED = 'Get Chat Clicked';
export const REPORT_PROBLEM_CLICKED = 'Report Problem Clicked';

// Captcha
export const CAPTCHA_SCREEN_SHOWN = 'Captcha Screen Shown';
export const CAPTCHA_ERROR_SHOWN = 'Captcha Error Shown';

// Common
export const FIELD_INFO_CLICKED = 'Field Info Clicked';

// Residency Address Unsupported Shown
export const RESIDENCY_ADDRESS_UNSUPPORTED_SHOWN = 'Residency Address Unsupported Shown';
export const CHANGE_RESIDENCE_ADDRESS_CLICKED = 'Change Residence Address Clicked';

// Braze banners
export const BANNER_SHOWN = 'Banner Shown';
export const BANNER_CLOSE_CLICKED = 'Banner Close Clicked';

// Personal data change
export const CHANGE_PHONE_NUMBER_CLICKED = 'Change Phone Number Clicked';
export const CHANGE_PERSONAL_INFO_CLICKED = 'Change Personal Info Clicked';

export const AMPLITUDE_EVENTS = {
    SIGN_UP_BUTTON_CLICKED,
    LOGIN_BUTTON_CLICKED,
    REGISTRATION_STARTED,
    LOGIN_OPENED,
    MOBILE_NUMBER_SCREEN_SHOWN,
    MOBILE_NUMBER_CONTINUE_CLICKED,
    COUNTRY_CODE_SELECTED,
    COUNTRY_CODE_LIST_OPENED,
    COUNTRY_CODE_CLICKED,
    CANT_RECOGNISE_NUMBER_SHOWN,
    CHANGE_PHONE_COUNTRY_CLICKED,
    REENTER_MANUALLY_CLICKED,
    ONBOARDING_COMPLETED,
    COMPLETE_PROFILE_BANNER_CLICKED,
    FORGOT_PASSCODE_CLICKED,
    PASSCODE_SET_SHOWN,
    PASSCODE_SUCCESSFULLY_ENTERED,
    MOBILE_NUMBER_ERROR_SHOWN,
    PERSONAL_INFO_SCREEN_SHOWN,
    PERSONAL_INFO_SCREEN_CONTINUE_CLICKED,
    ADRESS_SCREEN_SHOWN,
    ADRESS_SCREEN_CONTINUE_CLICKED,
    EMAIL_SCREEN_SHOWN,
    EMAIL_SCREEN_CONTINUE_CLICKED,
    COMPLETE_PROFILE_PROMO_SHOWN,
    COMPLETE_PROFILE_CONTINUE_CLICKED,
    COMPLETE_PROFILE_NOT_NOW_CLICKED,
    UNSUPPORTED_CHARACTERS_ERROR_SHOWN,
    UNSUPPORTED_CHARACTERS_GO_BACK_CLICKED,
    UNSUPPORTED_CHARACTERS_ACCEPT_CLICKED,
    COUNTRY_OF_RESIDENCE_CLICKED,
    SELECT_COUNTRY_OF_RESIDENCE_SCREEN_SHOWN,
    COUNTRY_OF_RESIDENCE_SELECTED,
    PERSONAL_DETAILS_UPDATED_SHOWN,
    RESIDENTIAL_ADDRESS_UPDATED_SHOWN,
    LOGOUT_COMPLETED,
    CODE_ENTERED,
    ENTER_CODE_SCREEN_SHOWN,
    CODE_ENTERED_WRONG,
    DID_NOT_GET_CODE_BUTTON_CLICKED,
    DID_NOT_GET_CODE_SCREEN_SHOWN,
    DID_NOT_GET_CODE_RESEND_CLICKED,
    DID_NOT_GET_CODE_SUPPORT_CLICKED,
    DROPDOWN_LIST_SHOWN,
    DROPDOWN_LIST_ITEM_SELECTED,
    CHECK_PHONE_NUMBER_BOTTOM_SHEET_SHOWN,
    USE_THIS_PHONE_NUMBER_CLICKED,
    TERMS_AND_AGREEMENT_SCREEN_SHOWN,
    TERMS_AND_AGREEMENT_ACCEPT_CLICKED,
    TERMS_AND_AGREEMENT_CONFIRMATION_SCREEN_SHOWN,
    TERMS_AND_AGREEMENT_CONTINUE_CLICKED,
    WAITLIST_SCREEN_SHOWN,
    WAITLIST_NOTIFY_ME_CLICKED,
    LEAVE_EMAIL_SCREEN_SHOWN,
    LEAVE_EMAIL_SEND_CLICKED,
    EMAIL_ADDED_SCREEN_SHOWN,
    GA_MAIN_SCREEN_SHOWN,
    GET_CARD_SELECTED,
    ADD_MONEY_SELECTED,
    GA_TOP_UP_METHOD_SELECTED,
    TOP_UP_COMPLETED,
    EXCHANGE_SELECTED,
    EXCHANGE_COMPLETED,
    KYC_NOTIFICATION_SHOWN,
    CARD_MAIN_SCREEN_SHOWN,
    NEW_ACCOUNT_ADDED,
    ACCOUNT_CHANGED,
    GET_ACCOUNT_DETAILS,
    SEND_MONEY_BUTTON_CLICKED,
    COUNTRY_AND_METHOD_SCREEN_SHOWN,
    RECEIVING_COUNTRY_SELECTED,
    DELIVERY_METHOD_SELECTED,
    ADDITIONAL_INFO_SHOWN,
    RECIPIENTS_LIST_SHOWN,
    RECIPIENT_SELECTED,
    RECIPIENT_ADDED,
    VIEW_RATES_FIRST,
    CALCULATOR_SETTING_CHANGED,
    SENDING_METHOD_SELECTED,
    NEW_EXTERNAL_CARD_ADDED,
    CVV_ADDED,
    CONFIRM_SEND_SHOWN,
    TRANSFER_SEND_CLICKED,
    TRANSFER_CONFIRMATION_SHOWN,
    REPEAT_TRANSFER_BUTTON_CLICKED,
    REQUEST_DELIVERY_OPTION_CLICKED,
    DELIVERY_METHOD_LIST_SHOWN,
    MORE_DETAILS_NEEDED_SCREEN_SHOWN,
    MORE_DETAILS_NEEDED_CONTINUE_CLICKED,
    METHOD_UNAVAILABLE_SHOWN,
    DISABLED_METHOD_CLICKED,
    IMPROVED_RATE_INFO_CLICKED,
    RECIPIENT_TYPE_LIST_SHOWN,
    RECIPIENT_TYPE_SELECTED,
    FEE_INFO_CLICKED,
    CHANGE_PAYMENT_OPTION_CLICKED,
    CVV_DIALOG_SHOWN,
    CVV_ENTERED,
    TRY_NOW_CLICKED,
    PROMO_SCREEN_SHOWN,
    COPY_RRN_CLICKED,
    RECIPIENT_DETAILS_SCREEN_SHOWN,
    RECIPIENT_DETAILS_CONTINUE_CLICKED,
    ADDITIONAL_RECIPIENT_INFO_SHOWN,
    ADDITIONAL_RECIPIENT_CONTINUE_CLICKED,
    ADDITIONAL_SENDER_INFO_SHOWN,
    ADDITIONAL_SENDER_INFO_CONTINUE_CLICKED,
    BANK_ACCOUNT_I_PAID_CLICKED,
    BANK_ACCOUNT_CANCELED_TRANSFER_BUTTON_CLICKED,
    BANK_ACCOUNT_I_WILL_PAY_LATER_BUTTON_CLICKED,
    BANK_ACCOUNT_PAY_CLICKED,
    TRANSFER_STATUS_DETAILS_CLICKED,
    TRANSFER_STATUS_SHOWN,
    REQUEST_MONEY_BUTTON_CLICKED,
    REQUESTEE_MOBILE_NUMBER_ADDED,
    REQUESTS_CALCULATOR_ADJUSTED,
    REQUESTS_PAYMENT_METHOD_SELECTED,
    REQUESTS_NEW_METHOD_ADDED,
    REQUESTS_CONFIRM_SHOWN,
    REQUESTS_CONFIRM_CLICKED,
    REQUESTS_CONFIRMATION_SHOWN,
    REQUEST_SHOWN,
    REQUEST_SEND_CLICKED,
    REQUEST_DECLINED,
    INCREASE_LIMITS_SHOWN,
    VERIFICATION_FAILED_SCREEN_SHOW,
    INCREASE_LIMITS_CONTINUE_CLICKED,
    INCREASE_LIMITS_DOCUMENTS_SELECTED,
    INCREASE_LIMITS_FAQ_SHOWN,
    INCREASE_LIMITS_DOCUMENTS_SUBMITTED,
    SENDING_LIMIT_ACHIEVE,
    CHAT_BUTTON_CLICKED,
    HOW_TO_SEND_DOCS_SCREEN_SHOWN,
    UZBEKISTAN_RESIDENCY_SCREEN_SHOWN,
    UZBEKISTAN_RESIDENCY_CONTINUE_CLICKED,
    OFAKIM_GENDER_VERIFICATION_CONTINUE_CLICKED,
    OFAKIM_HOW_TO_SEND_DOCS_SCREEN_SHOWN,
    ID_IN_REVIEW_SCREEN_GOT_IT_CLICKED,
    ACCOUNT_PURPOSE_SCREEN_SHOWN,
    ACCOUNT_PURPOSE_CONTINUE_CLICKED,
    NOT_NOW_CLICKED,
    VERIFICATION_SCREEN_SHOWN,
    VERIFY_IDENTITY_CLICKED,
    RESUME_TRANSFER_CLICKED,
    TRY_VERIFICATION_AGAIN_CLICKED,
    VERIFY_INDENTITY_BANNER_CLICKED,
    INCREASE_LIMITS_BANNER_CLICKED,
    FRAUD_SUSPICIOUS_SCREEN_SHOWN,
    FROZEN_ACCOUNT_SCREEN_SHOWN,
    BLOCK_GUIDANCE_SCREEN_SHOWN,
    CONTACT_SUPPORT_CLICKED,
    ADVANCED_ERROR_SCREEN_SHOWN,
    PLUS_PROMO_BANNER_CLICKED,
    PLUS_INITIAL_SCREEN_SHOWN,
    PLUS_SUBSCRIBE_BUTTON_CLICKED,
    HOW_PLUS_WORKS_SCREEN_SHOWN,
    HOW_TRANSFERS_WORKS_SCREEN_SHOWN,
    PLUS_SELECT_PAYMENT_CLICKED,
    PLUS_PAYMENT_SUMMARY_SCREEN_SHOWN,
    PLUS_CONFIRM_SUBSCRIPTION_CLICKED,
    PLUS_SEND_TRANSFER_CLICKED,
    PLUS_UPDATE_PAYMENT_CLICKED,
    PLUS_UPDATE_PAYMENT_SUCCESS,
    PLUS_BENEFIT_PROMO_SHOWN,
    PLUS_PROMO_CODE_SAVED,
    PAYOUT_NETWORKS_LIST_SHOWN,
    PAYOUT_NETWORK_SELECTED,
    CALCULATOR_SCREEN_SHOWN,
    SENDING_METHOD_SCREEN_SHOWN,
    TRANSFER_SHOWN,
    NOTIFY_RECIPIENT_CLICKED,
    NOTIFY_RECIPIENT_SCREEN_SHOWN,
    SHARE_DETAILS_CLICKED,
    PAYOUT_METHOD_GUIDE_SCREEN_SHOWN,
    PAYOUT_METHOD_GUIDE_BUTTON_CLICKED,
    AWAITING_TRANSFER_CLICKED,
    INCOMPLETE_TRANSFER_METHOD_NOT_AVAILABLE_SHOWN,
    AF_PURPOSE_OF_TRANSFERS_CONTINUED_CLICKED,
    AF_TRANSACTIONS_DETAILS_CONTINUED_CLICKED,
    AF_VERIFYING_PAYMENT_CARD_SCREEN_PROMO_SHOWN,
    AF_VER_PAYMENT_CARD_ENTERED_VER_AMOUNT_CONT_CLICKED,
    AF_VERIFYING_PAYMENT_CARD_AMOUNT_CONFIRMATION_COMPLETED,
    AF_REQUESTING_IDENTITY_DOCUMENT_PROMO_SCREEN_SHOWN,
    AF_REQUESTING_IDENTITY_DOCUMENT_DOCUMENT_SELECTED,
    AF_REQUESTING_IDENTITY_DOCUMENT_FAQ,
    AF_REQUESTING_IDENTITY_DOCUMENT_SUBMITTED_SHOWN,
    AF_REQUESTING_IDENTITY_MOTION_SUBMITTED_SHOWN,
    AF_ONFIDO_IN_REVIEW_PROMO_GOT_IT_CLICKED,
    AF_PROMO_PAYMENT_METHOD_VERIF_CONTINUE_CLICKED,
    AF_MORE_INFO_ABOUT_RECIPIENT_CONTINUE_CLICKED,
    AF_NOTIFY_RECIPIENT_SCREEN_SHOWN,
    AF_RECIPIENT_DETAILS_REQUIRED_BANNER_CLICKED,
    AF_RECIPIENT_VERIFICATION_LINK_COPY_CLICKED,
    AF_RECIPIENT_IDENTITY_REQUEST_PROMO_CONTINUE_CLICKED,
    AF_RECIPIENT_PERSONAL_DATA_PROCESSING_AGREE_CLICKED,
    AF_RECIPIENT_EMAIL_CONTINUE_CLICKED,
    AF_RECIPIENT_ONFIDO_IN_REVIEW_PROMO_DONE_CLICKED,
    AF_CHAT_BOT_BUTTON_CLICKED_WITH_SOURCE_OF_PAYMENT,
    SOF_SCREEN_SHOWN,
    SOF_SELECTED,
    CARD_VERIFICATION_CONTINUE_CLICKED,
    CARD_VERIFICATION_SCREEN_SHOWN,
    CARD_VERIFICATION_COMPLETED,
    BUSINESS_PAYMENT_LANDING_PAGE_VIEWED,
    GET_TRANSFER_STATEMENT_CLICKED,
    TIME_PERIOD_CLICKED,
    CUSTOM_DATES_CONTINUE_CLICKED,
    SEND_STATEMENT_CLICKED,
    STATEMENT_SENT_SHOWN,
    OPT_IN_BETA_CLICKED,
    OPT_IN_BETA_JOINED_SCREEN_SHOWN,
    OPT_IN_BETA_SCREEN_SHOWN,
    OPT_IN_BETA_MIGRATION_SCREEN_SHOWN,
    BONUS_INVITATION_CLICKED,
    SHARE_LINK_CLICKED,
    SHARE_LINK_CONFIRM_CLICKED,
    COPY_INVITE_LINK_CLICKED,
    COPY_INVITE_CODE_CLICKED,
    TRACK_MY_REFERRALS_CLICKED,
    INVITE_FRIENDS_CLICKED,
    PROFILE_SCREEN_SHOWN,
    BANNER_CLICKED,
    PAYEE_USE_BANK_DETAILS_CLICKED,
    PAYEE_GO_BACK_EDIT_CLICKED,
    PAYEE_CONTINUE_ANYWAY_CLICKED,
    PAYEE_PROCEED_DETAILS_CLICKED,
    PAYEE_CLOSE_MATCH_SHOWN,
    PAYEE_CLOSE_MATCH_WARNING_SHOWN,
    PAYEE_MISMATCH_SHOWN,
    PAYEE_MISMATCH_WARNING_SHOWN,
    ERROR_SCREEN_SHOWN,
    ERROR_SCREEN_TRY_AGAIN_SHOWN,
    ERROR_SCREEN_TRY_AGAIN_CLICKED,
    GET_HELP_CLICKED,
    GET_CHAT_CLICKED,
    REPORT_PROBLEM_CLICKED,
    CAPTCHA_SCREEN_SHOWN,
    CAPTCHA_ERROR_SHOWN,
    FIELD_INFO_CLICKED,
    RESIDENCY_ADDRESS_UNSUPPORTED_SHOWN,
    CHANGE_RESIDENCE_ADDRESS_CLICKED,
    BANNER_SHOWN,
    BANNER_CLOSE_CLICKED,
    CHANGE_PHONE_NUMBER_CLICKED,
    CHANGE_PERSONAL_INFO_CLICKED,
    GET_BETTER_RATE_CLICKED,
    OBQ_SCREEN_SHOWN,
    OBQ_CONTINUE_CLICKED,
} as const;

export type AmplitudeEventKey = keyof typeof AMPLITUDE_EVENTS;
export type AmplitudeEventValue = (typeof AMPLITUDE_EVENTS)[AmplitudeEventKey];
